import { gql } from "@apollo/client";

export const Get_Leads_columns = gql`
  query {
    leadsColumnInfo {
      columnName
      columnType
      columnDisplayName
      childColumnInfo {
        columnName
        columnType
      }
    }
  }
`;

export const Get_Lead_Search_Fields = gql`
  query {
    leadSearchFields(
      take: 100
      where: { and: [{ category: { eq: "Field" } }] }
    ) {
      items {
        key
        name
        uiHint
        type
        category
        operators {
          key
          value
        }
      }
    }
  }
`;
export const Get_SMS_Search_Fields = gql`
  query {
    smsSearchFields(
      take: 100
      where: { and: [{ category: { eq: "Field" } }] }
    ) {
      items {
        key
        name
        uiHint
        type
        category
        operators {
          key
          value
        }
      }
    }
  }
`;
export const Get_Email_Search_Fields = gql`
  query {
    emailSearchFields(
      take: 100
      where: { and: [{ category: { eq: "Field" } }] }
    ) {
      items {
        key
        name
        uiHint
        type
        category
        operators {
          key
          value
        }
      }
    }
  }
`;
export const Get_Appointment_Search_Fields = gql`
  query {
    appointmentSearchFields(
      take: 100
      where: { and: [{ category: { eq: "Field" } }] }
    ) {
      items {
        key
        name
        uiHint
        type
        category
        operators {
          key
          value
        }
      }
    }
  }
`;
export const Get_Lead_Search_Events = gql`
  query {
    leadSearchFields(
      take: 100
      where: { and: [{ category: { eq: "Event" } }] }
    ) {
      items {
        key
        name
        uiHint
        type
        category
        operators {
          key
          value
        }
      }
    }
  }
`;

export const Get_Lead_Update_Fields = gql`
  query {
    leadUpdateFields(take: 100) {
      items {
        key
        name
        uiHint
        type
      }
    }
  }
`;

export const Get_Leads_Grid = gql`
  query LeadsGridPagination(
    $skip: Int
    $take: Int
    $where: LeadGridFilterInput
    $order: [LeadGridSortInput!]
  ) {
    leadsGrid(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        firstName
        lastName
        createdOn
        leadOwnerId
        leadStatusId
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const Get_Lead_Grid_User_Setting = gql`
  query LeadGridUserSetting($userId: Int!) {
    leadGridSettings(userId: $userId) {
      columns
      columnFilters {
        columnName
        searchText
      }
      sortingInfo {
        columnName
        sortOrder
      }
    }
  }
`;

export const Get_Lead = (customFieldsQuery) => gql`
  query Lead($id: Int!) {
    leadDetails(id: $id ) {
        id
        lastActivity
        industryId
        languageId
        addressId
        createdOn
        modifiedOn
        salutation
        firstName
        lastName
        designation
        countryCode
        countryISOCode
        phone
        email
        alternateEmail
        alternateCountryCode
        alternatePhone
        preferredContactId
        leadOwnerId
        assignedTo
        street
        city
        state
        zipCode
        country
        countryId
        stateProvinceId
        description
        optIn
        optedOut
        value
        website
        leadStatusId
        contactId
        leadSourceId
        leadTypeId
        annualRevenue
        twitterUrl
        linkedInUrl
        skypeUrl
        score
        leadTags {
          tagId
        }
        leadAttachments {
          id
          userId
          leadId
          path
          name
          createdOn
          modifiedOn
        }
        ${customFieldsQuery}
        leadCustomMultipleValues {
          customFieldId
          selectedIds
        }
    }
  }
`;

export const Get_Lead_Attachments = gql`
  query Lead($id: Int!) {
    leadDetails(id: $id) {
      id
      leadAttachments {
        id
        userId
        leadId
        path
        name
        createdOn
        modifiedOn
      }
    }
  }
`;

export const Get_Notifications = gql`
  query Notification(
    $skip: Int
    $take: Int
    $where: NotificationFilterInput
    $order: [NotificationSortInput!]
  ) {
    notifications(where: $where, skip: $skip, take: $take, order: $order) {
      items {
        id
        userId
        data
        type
        isRead
        isDeleted
        createdOn
        description
        title
        isSeen
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

export const Get_Lead_Impot_History = gql`
  query leadsImportHistory(
    $skip: Int
    $take: Int
    $where: LeadsImportHistoryFilterInput
    $order: [LeadsImportHistorySortInput!]
  ) {
    leadsImportHistory(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
        path
        recordsCount
        recordsCreatedCount
        recordsUpdatedCount
        source
        userId
        createdOn
        status
        modifiedOn
        notifyViaEmail
        createdOn
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const Get_Companies = gql`
  query userCompanies($userEmail: String!) {
    userCompanies(userEmail: $userEmail) {
      id
      name
      companyKey
      roleName
    }
  }
`;

export const Get_Lists = gql`
  query GetList(
    $skip: Int
    $take: Int
    $where: ListFilterInput
    $order: [ListSortInput!]
  ) {
    lists(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
        createdBy
        createdOn
        criteria
        itemCount
        userDisplayName
        type
        workFlowId
        automationsUsedIn
      }
      totalCount
    }
  }
`;

export const Get_Leads_Count_In_List = gql`
  query GetList($where: ListLeadFilterInput) {
    listLeads(where: $where) {
      totalCount
    }
  }
`;

export const Get_Lead_Workflows = gql`
  query getLeadWorkflows($leadId: Int!, $skip: Int!, $take: Int!) {
    leadWorkflows(leadId: $leadId, skip: $skip, take: $take) {
      items {
        id
        workflowRunId
        workflowRunStatus
        userDisplayName
        leadSourceType
        leadRunStatus
        name
        listId
      }
      totalCount
    }
  }
`;

export const Get_Lead_Score_Details = gql`
  query getLeadScoringDetails($leadId: Int!) {
    leadScoringDetails(where: { leadId: { eq: $leadId } }) {
      items {
        score
        leadScoringRule {
          name
          score
          leadScoringRuleCriteria {
            title
            score
          }
        }
      }
    }
  }
`;

export const Get_SMS_Permission = gql`
  query getSMSPermission {
    generalSettings {
      enableSMSForNonOptedLeads
      modifiedBy
      createdBy
    }
  }
`;
export const Get_User_Settings = gql`
  query GetUserSettings(
    $userId: Int!
    $skip: Int
    $take: Int
    $where: UserSettingFilterInput
    $order: [UserSettingSortInput!]
  ) {
    userSetting(
      userId: $userId
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      items {
        id
        userId
        key
        value
        clientType
      }
    }
  }
`;

export const Get_Tasks = gql`
  query GetTasks(
    $skip: Int
    $take: Int
    $where: CRMTaskFilterInput
    $order: [CRMTaskSortInput!]
  ) {
    crmTasks(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        title
        assignedTo
        leadId
        taskReminderId
        startDate
        dueDate
        description
        taskPriorityId
        taskStatusId
        taskTypeId
        createdOn
        isCompleted
        firstName
        lastName
        commentCount
      }
    }
  }
`;

export const Get_Task_Comments = gql`
  query GetTaskComments($taskId: Int) {
    taskComments(where: { taskId: { eq: $taskId } }, order: [{ id: DESC }]) {
      items {
        id
        comment
        createdOn
        taskId
      }
    }
  }
`;
export const Get_Lead_Name = gql`
  query GetLeadName($id: Int) {
    leads(where: { id: { eq: $id } }) {
      items {
        id
        firstName
        lastName
      }
    }
  }
`;
